<template>
  <div class="member-import-box">
    <el-dialog width="50%" :title="title" :visible.sync="show" :close-on-click-modal='false' :append-to-body='isAppend' :class="{'member-import-dialog':isAppend}" @close='close'>
      <span slot="title" class="dialog-footer">
        <span>{{title}}</span>
      </span>
      <div class="upload-area">
        <el-upload class="upload-demo" ref='upload' multiple :show-file-list="false" :before-upload='beforeUpload' :on-change="onChange" action="/api/file/importFile" :auto-upload="false" :on-success="handleSuccess" name="files" :data='{"type":"master",isOver}'>
          <el-button type="success">+ 上传文件</el-button>
          <div slot="tip" class="el-upload__tip ext-info">支持扩展名: .xlsx .jpg .png .jpeg .bmp</div>
        </el-upload>
        <div class="file-list">

          <div class="file" v-for="(file,index) in fileList " :key="index">
            <div class="file-left">
              <img v-if="file.suffName.indexOf('xls')>-1" src="../../assets/img/xls.png" alt="" srcset="">
              <img v-else-if="file.suffName.indexOf('ppt')>-1" src="../../assets/img/ppt.png" alt="" srcset="">
              <img v-else-if="imgs.includes(file.suffName)" src="../../assets/img/jpg.png" alt="" srcset="">
              <img v-else-if="file.suffName.indexOf('pdf')>-1" src="../../assets/img/pdf.png" alt="" srcset="">
              <img v-else-if="['rar','zip'].includes(file.suffName)" src="../../assets/img/zip.png" alt="" srcset="">
              <img v-else src="../../assets/img/doc.png" alt="" srcset="">
              <span class="file-name">{{file.fileName}}</span>
            </div>
            <i class="el-icon-close" @click="removeFile(file)"></i>
          </div>
        </div>
      </div>
      <div class="down-demo">
        <span class="down-text">下载模板</span>
        <span class="down-link" @click="downDemo">
          <i class="el-icon-download"></i>
          下载导入模板
        </span>
      </div>
      <div class="desc">
        说明：每次导入上限为3000条，导入大量数据的情况下，请分批导入。
      </div>
      <div class="opt">
        <span>重复客户</span>
        <el-radio-group v-model="isOver">
          <el-radio label="0">忽略</el-radio>
          <el-radio label="1">覆盖</el-radio>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close" size="medium">取 消</el-button>
        <el-button type="primary" @click="callBack" size="medium">导 入</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as fileApi from '../../api/fileAPI'
import * as resourceApi from '../../api/resourceAPI'

export default {
  components: {

  },
  props: {
    'is-append': {
      type: Boolean,
      default: true
    },
    'is-project-import': {
      type: Boolean,
      default: false
    },
    'show': {
      type: Boolean,
      default: true
    },
    'title': {
      type: String,
      default: ""
    },
    'demo-name': {
      type: String,
      default: "master"
    },
  },
  data() {
    return {
      fileList: [],
      isOver: "0",
      imgs: ['jpg', 'jpeg', 'png', 'bmp'],
      memberList:[]

    };
  },
  computed: {

  },
  watch: {

  },
  created() {

  },
  async mounted() {
  },
  methods: {

    async callBack() {
      //this.$refs.upload.submit();
      let fileData = new FormData()
      this.fileList.forEach(file => {
        fileData.append("files", file.raw)
      })
      fileData.append('type', this.demoName)
      fileData.append('isOver', this.isOver)
      fileData.append('isProjectImport', this.isProjectImport)
      let res = await fileApi.importFile(fileData)
      if (res.flag) {
        this.$message.success(res.message)
        this.memberList = res.data
        this.fileList = [];
        this.$refs.upload.fileList = []
      } else {
        this.$message.error(res.message)
      }
      // this.$emit('getResult', this.user)

    },

    handleSuccess(res, file, fileList) {
      file.status = file.status
      let memberId = this.$route.params.id
      if (res.flag) {
        this.$message.success(res.message)
        // this.fileList.push({ projectId, uuid: res.data[0], fileName: file.name, tag: '实施方案', suffName: file.name.substring(file.name.lastIndexOf('.') + 1), type: 1 })
      } else {
        this.$message.error(res.message)
      }
      console.log("handleSuccess", this.fileList);
    },

    beforeUpload(file) {
      console.log("beforeUpload", file);
    },
    close() {

      this.$emit('close',this.memberList)
      this.memberList  = []
      this.$refs.upload.clearFiles()
      this.fileList = []
      this.type = '0'
    },
    downDemo() {
      fileApi.download({ fileName: this.demoName, type: 'demo' }).then(res => {
        const link = document.createElement('a');
        let blob = new Blob([res]);
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);

        link.setAttribute('download', this.demoName + "-demo.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link)

      })
    },
    onChange(file, fileList) {
      console.log("onChange", file);
      let arr = ['jpg', 'jpeg', 'png', 'bmp', 'xlsx']
      this.fileList = fileList.filter(f => arr.includes(f.name.substring(f.name.lastIndexOf('.') + 1))).map(f => {
        let file = { ...f }
        console.log("onChange", f);
        file.fileName = f.name
        file.suffName = f.name.substring(file.name.lastIndexOf('.') + 1)
        return file
      })
    },
    removeFile(file) {
      return this.$confirm(`确定移除 ${file.fileName}？`).then(() => {

        this.fileList = this.fileList.filter(f => f.uid != file.uid)
        this.$refs.upload.uploadFiles = this.$refs.upload.uploadFiles.filter(f => f.uid != file.uid)
      })

    },

  },
};
</script>

<style  lang="less">
.member-import-dialog {
  .el-dialog {
    max-width: 720px;
    .el-dialog__header {
      color: #3c4353;
      font-size: 24px;
      padding-bottom: 0;
    }
    .el-dialog__body {
      padding: 20px;
      .el-autocomplete {
        width: 100%;
        margin-right: 40px;
      }
      .upload-area {
        padding: 20px;
        border: 1px solid #dfdfe1;
        border-radius: 5px;
        // display: flex;
        // flex-direction: column;
        .file-list {
          max-height: 150px;
          overflow-y: auto;
        }
        .ext-info {
          font-size: 12px;
          color: #a6aab8;
          padding: 20px 0;
          margin: 0;
        }
        .file {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .file-left {
            cursor: pointer;
            display: flex;
            align-items: center;
            width: 240px;

            img {
              width: 16px;
            }
            .file-name {
              margin-left: 10px;
              font-size: 13px;
              color: #606266;
            }
          }

          > .el-icon-close {
            font-size: 18px;
            cursor: pointer;
            color: #606266;
          }
        }
        .file + .file {
          margin-top: 10px;
        }
      }
      .down-demo {
        color: #3c4353;
        font-size: 16px;
        margin-top: 20px;
        .down-text {
          width: 80px;
          display: inline-block;
        }
        .down-link {
          color: #0066cc;
          cursor: pointer;
        }
      }
      .desc {
        margin-top: 10px;
        color: #a6aab8;
      }
      .opt {
        color: #3c4353;
        font-size: 16px;
        margin-top: 10px;
        > span {
          width: 80px;
          display: inline-block;
        }
        .el-radio {
          color: #999;
          .el-radio__label {
            font-size: 16px;
          }
        }
      }
    }
    .el-dialog__footer {
      padding-right: 40px;
    }
  }
}
</style>
